export default "__VITE_ASSET__6cef1fe9__"